import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'

export const useProfileFillingFields = (
  profile: GQLForeignRootQuery['user']
) => {
  if (profile) {
    const dating = profile.dating
    const hasPhotoForSocial = Boolean(
      dating.materialStatus ||
        dating.homeStatus ||
        dating.children ||
        dating.education ||
        dating.knownLanguages ||
        dating.smoking ||
        dating.alcohol
    )

    const hasPhotoForTag = profile.interests.interests.nodes.length > 0

    return {
      hasPhotoForTag,
      hasPhotoForSocial,
    }
  }

  return {
    hasPhotoForTag: false,
    hasPhotoForSocial: false,
  }
}
